'use strict';

var translations = {
    warnings: {
        straightRow: '「asdf」のような直線的なキー配列は、推測されやすいので避けましょう。',
        simpleRepeat:
            '「aaa」と「abcabc」のような単語や文字の繰り返しは、推測されやすいので避けましょう。',
        extendedRepeat:
            '「aaa」と「abcabc」のような単語や文字の繰り返しは、推測されやすいので避けましょう。',
        sequences:
            '「abc」や「6543」のような順番が連続する文字は、推測されやすいので避けましょう。',
        recentYears: '「2020」のような最近の年は、推測されやすいので避けましょう。',
        dates: '日付は推測されやすいので、避けましょう。',
        topTen: '一般的によく使われるパスワードのため、避けましょう。',
        topHundred: '一般的によく使われるパスワードのため、避けましょう。',
        common: '一般的によく使われるパスワードのため、避けましょう。',
        similarToCommon: '一般的によく使われるパスワードのため、避けましょう。',
        wordByItself: '単語だけのパスワードは、推測されやすいので避けましょう。',
        namesByThemselves: '名前や姓だけのパスワードは、推測されやすいので避けましょう。',
        commonNames: '名前や姓だけのパスワードは、推測されやすいので避けましょう。',

        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: '一般的な単語はなるべく避け、複数の単語を組み合わせましょう。',
        anotherWord: 'もう一つか二つ、単語を追加しましょう。',
        repeated:
            '「aaa」と「abcabc」のような単語や文字の繰り返しは、推測されやすいので避けましょう。',
        l33t: '＠をaの代わりに使う（Appleを@ppleなど）のは、推測されやすいので避けましょう。',
        reverseWords:
            '「elppa」（appleの反対）のような単語を反対から読むようなパスワードは、推測されやすいので避けましょう。',
        allUppercase:
            '大文字のみ、または小文字のみのパスワードは、推測されやすいので避けましょう。',
        dates: '日付は推測されやすいので、避けましょう。',
        associatedYears: 'Avoid dates.',
        recentYears: '「2020」のような最近の年は、推測されやすいので避けましょう。',
        sequences:
            '「abc」や「6543」のような順番が連続する文字は、推測されやすいので避けましょう。',

        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
